window.addEventListener('alpine:init', () => {
  Alpine.store('localization', {
    region: null,
    async init() {
      try {
        const response = await fetch(
          window.Shopify.routes.root +
            'browsing_context_suggestions.json' +
            '?country[enabled]=true' +
            `&country[exclude]=${window.Shopify.country}` +
            '&language[enabled]=true' +
            `&language[exclude]=${window.Shopify.language}`
        ).then((r) => r.json());
        this.region = response.detected_values.country.handle;
      } catch (error) {
        this.region = 'US';
      }
    },
  });

  Alpine.store('localization').init();
});
